/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalibrationPerformanceModel } from './CalibrationPerformanceModel';
export type CalibrationModel = {
  readonly id?: number;
  readonly performances?: Array<CalibrationPerformanceModel>;
  readonly panel_id?: string;
  temp_public_comps_reference: string | null;
  name: string;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  calibration_date: string;
  transaction_allocation_method?: string;
  enterprise_value_inputs?: string;
  equity_value_inputs?: string;
  plus_cash_inputs?: string;
  less_debt_inputs?: string;
  ltm_revenue_inputs?: string | null;
  ltm_ebitda_inputs?: string | null;
  ntm_revenue_inputs?: string | null;
  ntm_ebitda_inputs?: string | null;
  ltm_revenue_multiple?: string | null;
  ntm_revenue_multiple?: string | null;
  ltm_revenue_multiple_percentile?: string | null;
  ntm_revenue_multiple_percentile?: string | null;
  ltm_revenue_multiple_premium?: string | null;
  ntm_revenue_multiple_premium?: string | null;
  ltm_ebitda_multiple?: string | null;
  ntm_ebitda_multiple?: string | null;
  ltm_ebitda_multiple_percentile?: string | null;
  ntm_ebitda_multiple_percentile?: string | null;
  ltm_ebitda_multiple_premium?: string | null;
  ntm_ebitda_multiple_premium?: string | null;
  data_updated?: boolean;
  revenue_premium_formula_selector?: CalibrationModel.revenue_premium_formula_selector;
  ebitda_premium_formula_selector?: CalibrationModel.ebitda_premium_formula_selector;
  valuation: number;
  public_comps_approach_calibration?: number | null;
  financials_version?: number | null;
};
export namespace CalibrationModel {
  export enum revenue_premium_formula_selector {
    MEDIAN = 'median',
    MEAN = 'mean',
    _25TH_PERCENTILE = '25th percentile',
    _75TH_PERCENTILE = '75th percentile',
    MIN = 'min',
    MAX = 'max',
  }
  export enum ebitda_premium_formula_selector {
    MEDIAN = 'median',
    MEAN = 'mean',
    _25TH_PERCENTILE = '25th percentile',
    _75TH_PERCENTILE = '75th percentile',
    MIN = 'min',
    MAX = 'max',
  }
}

